export class TaskAccumulationType {
	constructor() {
	}
} 
